// extracted by mini-css-extract-plugin
export default {"points":"Points_points__cHR04"};